/**
 * Formato de precios Oleum — sin .00 cuando el monto es entero.
 */
(function () {
  'use strict';

  function stripTrailingZeros(formatted) {
    if (formatted == null || formatted === '') return '';
    var s = String(formatted);
    if (/[.,]00$/.test(s)) return s.slice(0, -3);
    return s;
  }

  function formatMoney(cents, format) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return '';
    var raw;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      raw = window.Shopify.formatMoney(n, format || window.Shopify.money_format);
    } else {
      raw =
        '$' +
        (n / 100).toLocaleString('es-MX', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
    }
    return stripTrailingZeros(raw);
  }

  function formatMajorAmount(amount, currency) {
    var n = parseFloat(amount);
    if (!Number.isFinite(n)) return amount == null ? '' : String(amount);
    var hasCents = Math.round(n * 100) % 100 !== 0;
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: currency || 'MXN',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(n);
  }

  window.OleumFormatMoney = formatMoney;
  window.OleumFormatMajorMoney = formatMajorAmount;
  window.OleumStripTrailingZeros = stripTrailingZeros;
})();
